export default __webpack_public_path__ + "static/media/furnitureRental.a69026eb.png";